// removed by extract-text-webpack-plugin
module.exports = {"About":"___About__About___gsStY","Logos":"___About__Logos___3lPAi","logo":"___About__logo___1zSkE"};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/About/About.less
// module id = 1022
// module chunks = 0